<template>
  <div>
    <nav class="ng-nav">
      <div class="w1200">
        <div class="ng-all-category" v-on:mouseleave="hiddencategory()">
          <div class="ng-ac-title" v-on:mouseenter="showcategory()">
            <a
              :href="
                CurrentEnvPrefix.main + '/shop/index.php?act=category&op=index'
              "
              ><i class="fa fa-list" aria-hidden="true"></i
            ></a>
          </div>
          <div
            v-show="isshow"
            style="width:1200px;position:absolute;padding-top:15px;"
          >
            <div class="pn-category">
              <ul class="pn-menu">
                <li
                  class="pn-menulist"
                  v-for="(list, index) in classlist"
                  v-on:mouseenter="showsubclass(index)"
                  v-on:mouseleave="hiddensubclass(index)"
                >
                  <div class="pn-class">
                    <div class="pn-classname">
                      <p class="pn-span1">
                        <a
                          :href="
                            CurrentEnvPrefix.main +
                              '/shop/index.php?act=search&op=index&cate_id=' +
                              list.gc_id
                          "
                          >{{ list.gc_name }}</a
                        >
                      </p>
                      <p class="pn-span2">
                        <a
                          :href="
                            CurrentEnvPrefix.main +
                              '/shop/index.php?act=search&op=index&cate_id=' +
                              slist.gc_id
                          "
                          v-for="(slist, index) in list.subclass"
                          v-if="index < 2"
                          >{{ slist.gc_name
                          }}<span style="margin:0 5px;">/</span>
                        </a>
                        <i
                          class="fa fa-angle-right"
                          aria-hidden="true"
                          style="float:right"
                        ></i>
                      </p>
                    </div>
                  </div>
                  <div class="pn-subclass" v-show="isshow1 == index">
                    <div class="pn-subclass-main">
                      <div class="pn-subclass-content">
                        <ul class="pn-sc-list">
                          <li
                            class="pn-sc-item"
                            v-for="(slist, index) in list.subclass"
                          >
                            <a
                              :href="
                                CurrentEnvPrefix.main +
                                  '/shop/index.php?act=search&op=index&cate_id=' +
                                  slist.gc_id
                              "
                              class="pn-scname1"
                              >{{ slist.gc_name }}</a
                            >
                            <ul class="pn-sc-ul">
                              <li
                                class="pn-sc-li"
                                v-for="sclass in slist.subclass"
                              >
                                <a
                                  :href="
                                    CurrentEnvPrefix.main +
                                      '/shop/index.php?act=search&op=index&cate_id=' +
                                      sclass.gc_id
                                  "
                                  >{{ sclass.gc_name }}</a
                                >
                              </li>
                            </ul>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
              <div class="pn-store">
                <div class="pn-storelist">
                  <swiper
                    :options="swiperOption"
                    ref="mySwiper"
                    style="height:235px;"
                  >
                    <!-- slides -->
                    <swiper-slide
                      v-for="(list, index) in shoplist"
                      :key="index"
                    >
                      <a :href="list.ads[0].url" target="_blank">
                        <img :src="list.ads[0].pic" />
                        <p style="text-align:center;margin-top:10px;">
                          {{ list.store_name }}
                        </p>
                        <p style="text-align:center;">
                          <span
                            style="border:1px solid #FF3838;color:#ff3838;width:82px;height:20px;display:inline-block;text-align:center;line-height:20px;border-radius:12px"
                            >新进商家</span
                          >
                        </p>
                      </a>
                    </swiper-slide>
                    <!-- Optional controls -->
                    <div
                      class="swiper-pagination"
                      slot="pagination"
                      style="bottom:0;"
                    ></div>
                    <!-- <div class="swiper-button-prev  swiper-button-white" slot="button-prev" @click='slidePrev()'></div>
									    <div class="swiper-button-next  swiper-button-white" slot="button-next" @click='slideNext()'></div> -->
                  </swiper>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ul class="site-menu">
          <li>
            <a
              href="javascript:void(0)"
              @click="hrefClick(CurrentEnvPrefix.main)"
              >首页</a
            >
          </li>
          <li>
            <a
              href="/seasongoods?spm=act.pages.nav.seasonnewgoods"
              target="_blank"
              ref="cxxp"
              >换季新品</a
            >
          </li>
          <!-- <li><a href="/hotstore?spm=act.pages.nav.hotstore" target="_blank" ref="hotstore">人气商家</a></li> -->
          <!-- <li><a href="/purchase?spm=act.pages.nav.purchase" target="_blank" ref="wjcgj">旺季采购节</a></li> -->
          <!-- <li><a href="/topsupplier?spm=act.pages.nav.topsupplier" target="_blank" ref="sjyz">十佳供应商</a></li>
					<li><a href="/goodsupplier?spm=act.pages.nav.goodsupplier" target="_blank" ref="yzsj">优质供应商</a></li> -->
          <!-- <li><a href="/newtowel?spm=act.pages.nav.seasonnewgoods" target="_blank" ref="towel">毛巾新品</a></li> -->
          <!-- <li><a href="/jiafangcheng?spm=act.pages.nav.jiafangcheng" target="_blank" ref="jiafangcheng">三期市场</a></li> -->
          <!-- <li><a href="/zhounian?spm=act.pages.nav.zhounian" target="_blank" ref="zhounian">周年主推</a></li> -->
          <li>
            <a
              href="/newgoods?spm=act.pages.newgoods"
              target="_blank"
              ref="xbpa"
              >新帮派</a
            >
          </li>
          <li>
            <a
              href="/hotsearch?spm=act.pages.hotsalesgoods"
              target="_blank"
              ref="rbpa"
              >热帮派</a
            >
          </li>
          <!-- <li><a href="/brand?spm=act.pages.brands" target="_blank" ref="ppya">优选商家</a></li> -->
          <li>
            <a
              href="/videolist?spm=act.pages.videolist"
              target="_blank"
              ref="videolist"
              >视频空间</a
            >
          </li>
          <!-- <li><a href="/articlelist?spm=act.pages.nav.articlelist" target="_blank" ref="articlelist">品牌营</a></li> -->
          <!-- <li><a href="/channel?spm=act.pages.nav.channel" target="_blank" ref="channel">市场导航</a></li> -->
          <!-- <li><a href="/navigation?spm=act.pages.nav.all" target="_blank" ref="cja">市场导航</a></li> -->
          <!-- <li><a href="/wetchat?spm=act.pages.nav.wechat" target="_blank" ref="wsa">微商导航</a></li> -->
          <!-- <li><a href="/findgoods?spm=act.pages.nav.findgoods" target="_blank" ref="fxhh">发现好货</a></li> -->

          <!-- <li><a href="/tianmao?spm=act.pages.nav.tianmao" target="_blank" ref="tm">喵好店</a></li> -->
          <!-- <li><a href="/yiqing?spm=act.pages.nav.yiqing" target="_blank" ref="yiqing">疫情助力</a></li>
					<li><a href="/repeatwork?spm=act.pages.nav.repeatwork" target="_blank" ref="repeatwork">复工统计</a></li> -->
        </ul>
        <!-- <div class="ng-nav-tel">
					<span class="ng-tel-title">服务热线：</span>
					<span class="ng-tel-nub">400-0513-256</span>
				</div> -->
      </div>
    </nav>
  </div>
</template>

<style type="text/css" scoped>
.site-menu .router-link-exact-active.router-link-active {
  color: #ff2d51;
}
.swiper-slide {
  float: left;
}
.swiper-button-white {
  display: none;
  width: 20px;
  height: 20px;
  background-size: 100%;
  top: 56%;
}
.pn-store:hover .swiper-button-white {
  display: block;
}
</style>

<script>
// import './global/css/font-awesome/css/font-awesome.min.css'
// import VueAwesomeSwiper from 'vue-awesome-swiper'
import "swiper/dist/css/swiper.css";
import { CurrentEnvPrefix } from "config/urlprefix.js";
import { swiper, swiperSlide } from "vue-awesome-swiper";

export default {
  data() {
    return {
      CurrentEnvPrefix,
      isshow: false,
      isshow1: -1,
      classlist: [],
      shoplist: [],
      swiperOption: {
        autoplay: true,
        direction: "horizontal",
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          type: "bullets"
        },
        mousewheelControl: true
      }
    };
  },
  components: {
    swiper,
    swiperSlide
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    }
  },

  methods: {
    showcategory() {
      this.isshow = true;
    },
    hiddencategory() {
      this.isshow = false;
    },
    showsubclass(index) {
      this.isshow1 = index;
    },
    hiddensubclass(index) {
      this.isshow1 = -1;
    },
    getClassList() {
      this.$Api
        .get({ api: "/goods/goodsclass", param: { deep: 3, has_ad: 1 } })
        .then(response => {
          this.classlist = response.data.datas;
        });
    },
    hrefClick(href) {
      this.$HrefRouter.WebHrefRrouter(href);
    },
    getNavShop() {
      this.$Api.get({ api: "/ad/newshop/list" }).then(response => {
        this.shoplist = response.data.datas;
      });
    }
  },
  mounted() {
    this.getClassList();
    this.getNavShop();
    var path = this.$route.path;
    if (path == "/newgoods") {
      this.$refs.xbpa.style.color = "#ff2d51";
    } else if (path == "/hotsearch") {
      this.$refs.rbpa.style.color = "#ff2d51";
    } else if (path == "/brand") {
      this.$refs.ppya.style.color = "#ff2d51";
    } else if (path == "/navigation") {
      this.$refs.cja.style.color = "#ff2d51";
    } else if (path == "/wetchat") {
      this.$refs.wsa.style.color = "#ff2d51";
    } else if (path == "/seasongoods") {
      this.$refs.cxxp.style.color = "#ff2d51";
    } else if (path == "/newtowel") {
      // this.$refs.towel.style.color="#ff2d51";
    } else if (path == "/goodsupplier") {
      // this.$refs.yzsj.style.color="#ff2d51";
    } else if (path == "/topsupplier") {
      // this.$refs.sjyz.style.color="#ff2d51";
    } else if (path == "/purchase") {
      // this.$refs.wjcgj.style.color="#ff2d51";
    } else if (path == "/tianmao") {
      this.$refs.tm.style.color = "#ff2d51";
    } else if (path == "/yiqing") {
      this.$refs.yiqing.style.color = "#ff2d51";
    } else if (path == "/repeatwork") {
      this.$refs.repeatwork.style.color = "#ff2d51";
    } else if (path == "/findgoods") {
      this.$refs.fxhh.style.color = "#ff2d51";
    } else if (path == "/hotstore") {
      this.$refs.hotstore.style.color = "#ff2d51";
    } else if (path == "/jiafangcheng") {
      this.$refs.jiafangcheng.style.color = "#ff2d51";
    } else if (path == "/zhounian") {
      this.$refs.zhounian.style.color = "#ff2d51";
    } else if (path == "/channel") {
      this.$refs.channel.style.color = "#ff2d51";
    } else if (path == "/articlelist") {
      this.$refs.articlelist.style.color = "#ff2d51";
    } else if (path == "/videolist") {
      this.$refs.videolist.style.color = "#ff2d51";
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/public/publicnav.vue